/**
 * Klaviyo Back in Stock Initialization
 * This file handles the initialization of Klaviyo's back-in-stock functionality
 */

(function() {
  'use strict';

  // Wait for DOM to be ready and Klaviyo to be available
  function initializeKlaviyoBackInStock() {
    if (typeof klaviyo === 'undefined') {
      setTimeout(initializeKlaviyoBackInStock, 100);
      return;
    }

    // Get the localized strings from the window object
    const strings = window.klaviyo_bis || {};

    // Initialize Klaviyo
    klaviyo.init({ 
      account: 'NMghAC',
      platform: 'shopify',
      collection_urls: ["/collections/"]
    });

    // Enable back-in-stock functionality
    klaviyo.enable('backinstock', {
      trigger: {
        product_page_text: strings.product_page_text || 'Notify me when available',
        product_page_class: 'ProductForm__AddToCart button',
        product_page_text_align: 'center',
        product_page_margin: '0px',
        collection_page_class: 'button button--primary',
        collection_page_text_align: 'center',
        // collection_page_width: '200px',
        collection_page_text: strings.collection_page_text || 'Notify me',
        // collection_page_padding: 'inherit',
        alternate_anchor: "AddToCart",
      },
      modal: {
        headline: '{product_name}',
        body_content: strings.body_content || 'Register to receive a notification when this item comes back in stock.',
        email_field_label: strings.email_field_label || 'Email',
        button_label: strings.button_label || 'Notify me when available',
        subscription_success_label: strings.subscription_success_label || 'You are subscribed! We will notify you when this product is back.',
        footer_content: strings.footer_content || '',
        close_label: 'Close',

        additional_styles: "@import url('https://fonts.googleapis.com/css?family=Helvetica+Neue'); @import url('" + (window.klaviyo_bis?.styles_url || '/assets/klaviyo-styles.css') + "');",
        font_family: '"Helvetica Neue", Helvetica, Arial, sans-serif;',

        drop_background_color: '#000',
        background_color: '#fff',
        text_color: '#222',
        button_text_color: '#fff',
        button_background_color: '#000',
        close_button_color: '#ccc',
        error_background_color: '#fcd6d7',
        error_text_color: '#C72E2F',
        success_background_color: '#d3efcd',
        success_text_color: '#1B9500'
      }
    });
  }

  // Start initialization when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeKlaviyoBackInStock);
  } else {
    initializeKlaviyoBackInStock();
  }
})(); 